import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ContextProvider from './context/ContextProvider';
import './index.scss';
import reportWebVitals from './reportWebVitals';

/**
 * @fileoverview WAIVER DOCUMENTATION<br>
 * @author Ridwan Abiola
 * @see <a href="https://ridwanabiola.netlify.app">Ridwan Abiola</a>
 * @version 2.0.0
 */
ReactDOM.render(
	<ContextProvider>
		<App />
	</ContextProvider>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
